import {
  GetSeasonStatistics as GetSeasonStatisticsAction,
  GetSeasonStatisticsPayload,
} from "../../providers/supabase-provider/actions/GetSeasonStatistics";
import type { IPlayerSeasonStats } from "../../entities";

export { GetSeasonStatisticsPayload };

export const GetSeasonStatistics = async (
  payload: GetSeasonStatisticsPayload
): Promise<IPlayerSeasonStats[]> => {
  return await GetSeasonStatisticsAction(payload);
};
